function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgCheckboxChecked = function SvgCheckboxChecked(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 14 14",
    style: {
      enableBackground: "new 0 0 14 14"
    },
    xmlSpace: "preserve"
  }, props), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#342616"
    },
    d: "M4 4h6v6H4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14 14H0V0h14v14zM1 13h12V1H1v12z",
    style: {
      opacity: 0.5,
      fill: "#2d2d2d"
    }
  }));
};

export { SvgCheckboxChecked as ReactComponent };
export default "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0idXRmLTgiPz4KPCEtLSBHZW5lcmF0b3I6IEFkb2JlIElsbHVzdHJhdG9yIDIzLjAuNCwgU1ZHIEV4cG9ydCBQbHVnLUluIC4gU1ZHIFZlcnNpb246IDYuMDAgQnVpbGQgMCkgIC0tPgo8c3ZnIHZlcnNpb249IjEuMSIgaWQ9IkViZW5lXzEiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgeG1sbnM6eGxpbms9Imh0dHA6Ly93d3cudzMub3JnLzE5OTkveGxpbmsiIHg9IjBweCIgeT0iMHB4IgoJIHZpZXdCb3g9IjAgMCAxNCAxNCIgc3R5bGU9ImVuYWJsZS1iYWNrZ3JvdW5kOm5ldyAwIDAgMTQgMTQ7IiB4bWw6c3BhY2U9InByZXNlcnZlIj4KPHN0eWxlIHR5cGU9InRleHQvY3NzIj4KCS5zdDB7ZmlsbDojMzQyNjE2O30KCS5zdDF7b3BhY2l0eTowLjU7ZmlsbDojMkQyRDJEO30KPC9zdHlsZT4KPHRpdGxlPmNoZWNrYm94Y2hlY2tlZDE8L3RpdGxlPgo8cmVjdCB4PSI0IiB5PSI0IiBjbGFzcz0ic3QwIiB3aWR0aD0iNiIgaGVpZ2h0PSI2Ii8+CjxwYXRoIGNsYXNzPSJzdDEiIGQ9Ik0xNCwxNEgwVjBoMTRWMTR6IE0xLDEzaDEyVjFIMVYxM3oiLz4KPC9zdmc+Cg==";